import React from 'react'
import './Home.css'
// import hero from '/image/hero.svg'
import skill1 from '../pic/react.png'
import skill2 from '../pic/node.png'
import skill4 from '../pic/golang.png'
import { Typewriter } from 'react-simple-typewriter'

const Home = () => {
  return (
    <>
      <section className='hero' id='home'>
        <div className='container f_flex top'>
          <div className='left top'>
            <h3>WELCOME TO MY WORLD</h3>
            <h1>
              Hi, I’m <span>Nasution</span>
            </h1>
            <h2>
              a
              <span>
                <Typewriter
                  words={[' Professional Coder.', ' Developer.']}
                  loop
                  cursor
                  cursorStyle='|'
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                />
              </span>
            </h2>

            <p>
              I am an enthusiastic, self-motivated, reliable, responsible and
              hard working person.{' '}
              <span id='long-desc'>
                {' '}
                I am a mature team worker and adaptable to all challenging
                situations. I am able to work well under pressure and adhere to
                strict deadlines{' '}
              </span>
            </p>

            <div className='hero_btn d_flex_button_hero'>
              <div className='col_1'>
                <h4 style={{ marginBottom: '46px' }}>FIND WITH ME</h4>
                <div className='button'>
                  <a
                    href='https://github.com/nascript/'
                    target='_blank'
                    className='btn_shadow'
                    rel='noreferrer'
                  >
                    <i class='fab fa-github'></i>
                  </a>
                  <a
                    href='https://www.linkedin.com/in/nasutioncode/'
                    target='_blank'
                    className='btn_shadow'
                    rel='noreferrer'
                  >
                    <i class='fab fa-linkedin-in'></i>
                  </a>
                  <a
                    href='https://www.instagram.com/nascodefy/'
                    target='_blank'
                    className='btn_shadow'
                    rel='noreferrer'
                  >
                    <i class='fab fa-instagram'></i>
                  </a>
                </div>
              </div>
              <br />
              <div className='col_1'>
                <h4>BEST SKILL ON</h4>
                <button className='btn_shadow_skill'>
                  <img src={skill1} alt='' />
                </button>
                <button className='btn_shadow_skill'>
                  <img src={skill2} alt='' />
                </button>
                {/* <button className='btn_shadow_skill'>
                  <img src={skill3} alt='' />
                </button> */}
                <button className='btn_shadow_skill'>
                  <img src={skill4} alt='' />
                </button>
              </div>
            </div>
          </div>
          <div className='right'>
            <div className='right_img'>
              <img id='image2' src='/image/test2.jpg' alt='' />
              <img id='image1' src='/image/test.jpg' alt='' />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
